/*
 * Copyright (c) 2016 Omnigon Communications, LLC. All rights reserved.
 *
 * This software is the confidential and proprietary information of Omnigon Communications, LLC
 * ("Confidential Information"). You shall not disclose such Confidential Information and shall access and use it only
 * in accordance with the terms of the license agreement you entered into with Omnigon Communications, LLC, its
 * subsidiaries, affiliates or authorized licensee. Unless required by applicable law or agreed to in writing, this
 * Confidential Information is provided on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 * express or implied. See the license agreement for the specific language governing permissions and limitations.
 */

import BaseWidget from 'scripts/base-widget';
import FeedService from 'scripts/services/base-feed-service';
import Model from 'can/model/model';
import 'components/recap/player-header/player-header';

const playerFeedUrl = window.globalSettings.feeds.smt.playerUrl;

export const PlayerRecapHeader = BaseWidget.extend({
    init() {
        const player = this.options.player || null;
        this.viewModel = new playerRecapModel({
            player: player,
            playerInfo: null,
            backgroundImage: this.options.backgroundImage,
        });
        this.view = can.stache(`
            <player-header-recap
                {player}="player"
                {player-info}="playerInfo"
                {background-image}="backgroundImage"
            />`);
        this._super();
        this.fetchData(player);
    },

    fetchData(player) {
        this.feedService = new FeedService({
            feedUrl: playerFeedUrl,
            fromCache: false,
        });
        this.feedService
            .on('fetching', (ev, value) =>
                this.viewModel.attr('fetching', value),
            )
            .on('data', (ev, data) => {
                this.viewModel.attr('playerInfo', data);
                $('body').trigger('recapIsReady');
            });
        this.feedService.fetch({ identifier: player.identifier });
    },
});

const playerRecapModel = Model.extend(
    {},
    {
        define: {
            fetching: {
                type: 'boolean',
                value: true,
            },
            player: {
                Type: can.Map,
                value: null,
            },
            playerInfo: {
                Type: can.Map,
                value: null,
            },
            backgroundImage: {
                Type: can.Map,
                value: null,
            },
        },
    },
);
